import Select, { Option } from "@ingka/select";
import React from "react";
import { useTranslation } from "react-i18next";
import { getStoreList, useAppContext } from "../contextProviders/AppContext";
import { Store } from "../types/model";

type Props = {
  onChange: any;
  selectedStore: Store;
};

const sortStores = (a: Store, b: Store) => {
  if (a.storeName > b.storeName) {
    return 1;
  } else if (a.storeName < b.storeName) {
    return -1;
  }
  return 0;
};

const StoreSelector = (props: Props) => {
  const { useSelector } = useAppContext();
  const { t } = useTranslation();
  const stores: Array<Store> = useSelector(getStoreList);

  return (
    <Select
      id="selectStore"
      onChange={props.onChange}
      value={props.selectedStore?.storeNo || ""}
      label={t("event.chooseLocation")}
      hintText={t("event.chooseLocation")}
    >
      {stores.sort(sortStores).map((s: Store, i) => (
        <Option key={i} value={s.storeNo} name={s.storeName} />
      ))}
    </Select>
  );
};

export default React.memo(StoreSelector);
